<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
   
        <el-col :span="24">
          <el-form-item label="选择归属上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
        </el-col>
             <el-col :span="24">
          <el-form-item label="选择等级" prop="type">
            <el-radio-group v-model="form_data.type">
              <el-radio :label="2">街道</el-radio>
              <el-radio :label="3">社区</el-radio>
              <el-radio :label="4">部门</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否节点" prop="is_node">
            <el-radio-group v-model="form_data.is_node">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="选择归属上级" prop="pid">
            
            <el-select @visible-change="func_click" v-model="form_data.pid" placeholder="请选择" clearable :disabled="form_data.is_node!=0">
              <el-option label="无" :value="0"></el-option>
              <el-option v-show="form_data.type!=''&&form_data.type==item.type" v-for="(item, index) in nodeList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable :disabled="form_data.is_node!=0"></el-cascader>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="街道社区名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="是否公共" prop="is_public">
            <el-radio-group v-model="form_data.is_public">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form_data.is_public == 2">
          <el-form-item label="私有归属场所类型" prop="place_type" >
            <el-radio-group v-model="form_data.place_type">
              <el-radio :label="2">三小场所</el-radio>
              <el-radio :label="3">出租房</el-radio>
              <el-radio :label="4">公共场所</el-radio>
              <el-radio :label="5">工业企业</el-radio>
              <el-radio :label="6">大型商业综合体</el-radio>
              <el-radio :label="7">住宅小区</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import {
  types
} from './lavel.js';
// console.log(types)
export default {
  name: 'l-department-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    place_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list() {
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    "form_data.pid"() {
      if (!this.getdata_flag) {
        this.form_data.type = ""
      } else {
        this.getdata_flag = false
      }
      this.changes();
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      LAVEL_LIST: types,
      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        is_node: 0,
        pid: "",
        name: '',
        type: '',
        abbreviation: '',
        place_type: '',
        is_public: 1,
      },
      nodeList: [],
      type_name: "",
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '内容不能为空', trigger: 'change' }
        ],
        abbreviation: [
          { required: true, message: '缩写不能为空', trigger: 'change' }
        ],
        type: [
          { required: true, message: '等级不能为空', trigger: 'change' }
        ],
        pid: [
          { required: true, message: '上级不能为空', trigger: 'change' }
        ],
        is_public: [
          { required: true, message: '公共不能为空', trigger: 'change' }
        ],
        is_node: [
          { required: true, message: '节点不能为空', trigger: 'change' }
        ],
        // pid: [
        //   { required: true, message: '所属上级不能为空', trigger: 'change' }
        // ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    changes() {
      this.$_invoke("industry_getData", {
        type: this.form_data.type
      }).then((ret) => {  
        this.nodeList = ret.data
      })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取数据
    getData() {
      this.$_invoke(`communitySector_saveData`, ).then((ret) => {
console.log(ret);
        this.tree_node = ret.tree_node;
      }).finally(() => {
        this.loading = false;
      });
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`communitySector_details`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          // this.tree_node = ret.superior;
          this.getdata_flag = true
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // this.form_data.use_type = this.$props.useType
      }

    },


    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          let form_data = Object.assign({}, this.form_data);
          // console.log(typeof form_data.pid)
          if (typeof form_data.pid != "number") {
            const pid_len = form_data.pid.length;
            form_data.pid = form_data.pid[pid_len - 1];
          }
          this.submitting = true;
          this.form_data.place_type = 3;
          if (!this.hasId) {//添加
            this.$_invoke('communitySector_save', form_data).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`communitySector_update`, {
              id: this.$props.id,
              ...form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>